// src/lib/analytics.ts
// Google Analytics 4 with Core Web Vitals
export const GA_TRACKING_ID = import.meta.env.VITE_GA_ID

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: string) => {
  if (
    typeof window !== 'undefined' &&
    window.gtag &&
    typeof GA_TRACKING_ID === 'string'
   ) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    })
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }: {
  action: string
  category: string
  label?: string
  value?: number
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
  }
}

// Core Web Vitals tracking - Fixed parameter usage
export const sendToGoogleAnalytics = ({ name, delta, id }: {
  name: string
  delta: number
  value: number // Keep for web-vitals compatibility but don't use
  id: string
}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      non_interaction: true,
    })
  }
}